import { ComboChart } from '../../charts/ComboChart';
import { ChartModelHelper } from '../../helpers/ChartModelHelper';
import type { IComponentFacts } from '../../types/report';
import { EmptyFacts } from '../EmptyFacts';
import {
  CURRENCY_AXIS_WIDTH,
  moneyFormatter,
  percentFormatter,
} from './chartFormatters';
import { useChartStyle } from './useChartStyle';
import { useTrendMonths } from './useTrendMonths';

interface IPayrollTrendChartProps {
  facts: IComponentFacts;
}

const LABELS = {
  payroll: 'Payroll',
  nonPayroll: 'Non-payroll',
  payrollShare: 'Payroll % of opex',
};

export const PayrollTrendChart = ({ facts }: IPayrollTrendChartProps) => {
  const months = useTrendMonths(facts, { allowPreliminary: true });
  const style = useChartStyle(3);
  const rows = ChartModelHelper.payrollTrend(facts.table, months);
  if (!ChartModelHelper.hasSeries(rows, 'payroll')) return <EmptyFacts />;
  return (
    <ComboChart
      {...style}
      className="h-full"
      data={ChartModelHelper.relabel(rows, LABELS)}
      index="label"
      enableBiaxial
      barSeries={{
        categories: [LABELS.payroll, LABELS.nonPayroll],
        colors: ['blue', 'amber'],
        type: 'stacked',
        valueFormatter: moneyFormatter(facts.currency),
        yAxisWidth: CURRENCY_AXIS_WIDTH,
      }}
      lineSeries={{
        categories: [LABELS.payrollShare],
        colors: ['emerald'],
        valueFormatter: percentFormatter,
        yAxisWidth: 44,
        minValue: 0,
        maxValue: 1,
        connectNulls: true,
      }}
    />
  );
};
